import React, {
  useContext,
  useEffect
} from "react";

import { GlobalDataContext } from "../GlobalDataContext";

import { NoteDuration } from "../model/core";
import { ApiFactory } from "../ApiClient";
import PianoRoll from "./rolls/PianoRoll";

const API = ApiFactory.create();

function ChordRecognizer() {

  const [activeNotes, setActiveNotes] = React.useState([]);
  const [chordId, setChordId] = React.useState([]);
  const globalData = useContext(GlobalDataContext);

  useEffect(() => {
    API.getChordIdByNotes(activeNotes).then((response) => {
      response.json().then((data) => {
        console.log('chordId', data);
        setChordId(data);
      });
    });
  }, [activeNotes]);

  if (!globalData || globalData.loading) return <div>Loading...</div>;

  const toneLadder = globalData.data.tones;

  return (
    <div>
      {activeNotes.map((n, i) => <div key={i}>{n}</div>)}
      <table>
        <thead>
          <tr>
            <td></td>
            <td>Chord</td>
            <td>Root</td>
            <td>Family</td>
          </tr>
        </thead>

        {chordId.map((c, i) =>
          <tr key={c}>
            <td>{i}</td>
            <td>{c.name}</td>
            <td>{toneLadder[c.root]}</td>
            <td>{c.tones}</td>
          </tr>
        )}
      </table>
      <PianoRoll
        readonly={false}
        data={{ noteGroups: [{notes:[], duration: new NoteDuration(1)}] }}
        pianoRollUpdatedCB={(ngs) => setActiveNotes(ngs[0].notes)} />
    </div>
  );
}
export default ChordRecognizer;